import DatePicker from "../../Genericos/DatePicker/DatePicker";
import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { localidad } from "../../../context/Actions/localidad/localidad";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import {
  setUsuario,
  setListError,
} from "../../../context/Actions/registro/registro";
import { setPasoMultiTab } from "../../../context/Actions/multiTab/multiTab";
import { validaMobile } from "../../../context/Actions/registro/validaMobile";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import {
  regexEmail,
  regexEmailCaracteres,
  regexNombre,
  regexNombreCaracteres,
  regexTelefono,
  regexDomicilio,
} from "../../../../global/utils/expresionesRegulares";
import { filtrarPorRegex } from "../../../../global/utils/inputValidators";
import { obraSocial } from "../../../context/Actions/obraSocial/obraSocial";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";

const Paso1 = () => {
  const hoy = new Date();
  const {
    localidadState,
    localidadDispatch,
    registroState,
    registroDispatch,
    multiTabDispatch,
    validaMobileDispatch,
    validaMobileState,
    obraSocialDispatch,
  } = useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);

  const campos = [
    "nombre",
    "apellido",
    "email",
    "fecha_nacimiento",
    "idlocalidad",
    "domicilio",
    "telefono_movil",
  ];
  const [valueLocalidad, setValueLocalidad] = useState("");

  const isNombreApellidoError = (
    nombre,
    minLength = 3,
    validarFormato = false
  ) => {
    if (nombre === "") {
      return true;
    }
    // Verificar que no sea solo espacios
    if (nombre.trim() === "") {
      return true;
    }
    // Verificar longitud del valor sin espacios al inicio/fin
    if (nombre.trim().length < minLength) {
      return true;
    }
    // Solo validar formato estricto cuando se solicite (al enviar el formulario)
    if (validarFormato && !regexNombre.test(nombre.trim())) {
      return true;
    }
    return false;
  };
  //manejo de estados de todos los input
  const onNombreChange = (e) => {
    const valorNuevo = e.target.value;
    const valorActual = registroState.registro.usuario.nombre;

    // Permitir campo vacío
    if (valorNuevo === "") {
      let errx = { ...registroState.registro.listError };
      errx.nombre = true;
      setListError(errx)(registroDispatch);

      let usuario = { ...registroState.registro.usuario };
      usuario.nombre = "";
      setUsuario(usuario)(registroDispatch);
      return;
    }

    // No permitir que el campo empiece con espacio
    if (valorActual === "" && valorNuevo.startsWith(" ")) {
      e.target.value = valorActual;
      showToaster(
        {
          texto: "El nombre no puede empezar con espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);
      return;
    }

    // Filtro genérico por regex (permite letras, acentos y espacios)
    const { esValido, valorSanitizado } = filtrarPorRegex(
      valorNuevo,
      regexNombreCaracteres
    );

    if (!esValido) {
      // Revertimos visualmente al último valor válido
      e.target.value = valorActual;

      // Siempre muestro toaster cuando intenta ingresar algo inválido
      showToaster(
        {
          texto: "Solo se permiten letras y espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);

      // Solo marco error si el campo está vacío o incompleto
      if (!valorActual || valorActual.length < 3) {
        let errx = { ...registroState.registro.listError };
        errx.nombre = true;
        setListError(errx)(registroDispatch);
      }
      return;
    }

    // Verificar si solo son espacios
    if (valorSanitizado.trim() === "") {
      showToaster(
        {
          texto: "El nombre no puede contener solo espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);

      let errx = { ...registroState.registro.listError };
      errx.nombre = true;
      setListError(errx)(registroDispatch);

      e.target.value = valorActual;
      return;
    }

    let errx = { ...registroState.registro.listError };
    errx.nombre = isNombreApellidoError(valorSanitizado, 3);
    setListError(errx)(registroDispatch);

    let usuario = { ...registroState.registro.usuario };
    usuario.nombre = valorSanitizado;
    setUsuario(usuario)(registroDispatch);
  };

  const onApellidoChange = (e) => {
    const valorNuevo = e.target.value;
    const valorActual = registroState.registro.usuario.apellido;

    // Permitir campo vacío
    if (valorNuevo === "") {
      let errx = { ...registroState.registro.listError };
      errx.apellido = true;
      setListError(errx)(registroDispatch);

      let usuario = { ...registroState.registro.usuario };
      usuario.apellido = "";
      setUsuario(usuario)(registroDispatch);
      return;
    }

    // No permitir que el campo empiece con espacio
    if (valorActual === "" && valorNuevo.startsWith(" ")) {
      e.target.value = valorActual;
      showToaster(
        {
          texto: "El apellido no puede empezar con espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);
      return;
    }

    // Filtro genérico por regex (permite letras, acentos y espacios)
    const { esValido, valorSanitizado } = filtrarPorRegex(
      valorNuevo,
      regexNombreCaracteres
    );

    if (!esValido) {
      // Revertimos visualmente al último valor válido
      e.target.value = valorActual;

      // Siempre muestro toaster cuando intenta ingresar algo inválido
      showToaster(
        {
          texto: "Solo se permiten letras y espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);

      // Solo marco error si el campo está vacío o incompleto
      if (!valorActual || valorActual.length < 3) {
        let errx = { ...registroState.registro.listError };
        errx.apellido = true;
        setListError(errx)(registroDispatch);
      }
      return;
    }

    // Verificar si solo son espacios
    if (valorSanitizado.trim() === "") {
      showToaster(
        {
          texto: "El apellido no puede contener solo espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);

      let errx = { ...registroState.registro.listError };
      errx.apellido = true;
      setListError(errx)(registroDispatch);

      e.target.value = valorActual;
      return;
    }

    let errx = { ...registroState.registro.listError };
    errx.apellido = isNombreApellidoError(valorSanitizado, 3);
    setListError(errx)(registroDispatch);

    let usuario = { ...registroState.registro.usuario };
    usuario.apellido = valorSanitizado;
    setUsuario(usuario)(registroDispatch);
  };

  //revisar las validaciones, se pueden mejorar
  const onFechaNacChange = (e) => {
    let usuario = Object.assign({}, registroState.registro.usuario);
    let errx = Object.assign({}, registroState.registro.listError);
    if (e !== null) {
      usuario.fecha_nacimiento = e;
      setUsuario(usuario)(registroDispatch);
      errx.fecha_nacimiento = false;
      setListError(errx)(registroDispatch);
    } else {
      usuario.fecha_nacimiento = "";
      setUsuario(usuario)(registroDispatch);
      errx.fecha_nacimiento = true;
      setListError(errx)(registroDispatch);
    }
  };

  const isErrorEmail = (email) => {
    if (email === "") {
      return true;
    }
    // Verificar que no sea solo espacios
    if (email.trim() === "") {
      return true;
    }
    // Los emails no deberían tener espacios, validamos sin trim
    if (email.length < 4) {
      return true;
    }
    if (!regexEmail.test(email)) {
      return true;
    }
    return false;
  };

  const onEmailChange = (e) => {
    const valorNuevo = e.target.value;
    const valorActual = registroState.registro.usuario.email;

    // Permitir campo vacío
    if (valorNuevo === "") {
      let errx = { ...registroState.registro.listError };
      errx.email = true;
      setListError(errx)(registroDispatch);

      let usuario = { ...registroState.registro.usuario };
      usuario.email = "";
      setUsuario(usuario)(registroDispatch);
      return;
    }

    // No permitir que el campo empiece con espacio (los emails no deberían tener espacios)
    if (valorActual === "" && valorNuevo.startsWith(" ")) {
      e.target.value = valorActual;
      showToaster(
        {
          texto: "El email no puede empezar con espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);
      return;
    }

    // Filtro genérico por regex
    const { esValido, valorSanitizado } = filtrarPorRegex(
      valorNuevo,
      regexEmailCaracteres
    );

    if (!esValido) {
      // Revertimos visualmente al último valor válido
      e.target.value = valorActual;

      // Siempre muestro toaster cuando intenta ingresar algo inválido
      showToaster(
        {
          texto: "Caracteres no permitidos en el email",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);

      // Solo marco error si el campo está vacío o incompleto
      if (
        !valorActual ||
        valorActual.length < 4 ||
        !regexEmail.test(valorActual)
      ) {
        let errx = { ...registroState.registro.listError };
        errx.email = true;
        setListError(errx)(registroDispatch);
      }
      return;
    }

    let errx = { ...registroState.registro.listError };
    errx.email = isErrorEmail(valorSanitizado);
    setListError(errx)(registroDispatch);

    let usuario = { ...registroState.registro.usuario };
    usuario.email = valorSanitizado;
    setUsuario(usuario)(registroDispatch);
  };

  //revisar esta validacion
  const isLocalidadError = (localidad) => {
    if (localidad !== undefined) {
      if (localidad === "") {
        return true;
      } else return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (
      Array.isArray(localidadState.localidad.data) &&
      localidadState.localidad.data.length > 0
    ) {
      let valueLocalidad = localidadState.localidad.data.filter(
        (item) => item.id === registroState.registro.usuario.idlocalidad
      );
      if (
        Array.isArray(localidadState.localidad.data) &&
        valueLocalidad.length > 0
      ) {
        setValueLocalidad(valueLocalidad[0].id);
      }
    }
  }, [
    localidadState.localidad.data,
    registroState.registro.usuario.idlocalidad,
  ]);

  const onLocalidadChange = (e) => {
    if (e !== undefined) {
      if (e === "") {
        let usuario = Object.assign({}, registroState.registro.usuario);
        let errx = Object.assign({}, registroState.registro.listError);
        errx.idlocalidad = isLocalidadError(e);
        setListError(errx)(registroDispatch);
        usuario.idlocalidad = "";
        setUsuario(usuario)(registroDispatch);
      } else {
        let usuario = Object.assign({}, registroState.registro.usuario);
        let errx = Object.assign({}, registroState.registro.listError);
        errx.idlocalidad = isLocalidadError(e);
        setListError(errx)(registroDispatch);
        usuario.idlocalidad = e.id;
        setUsuario(usuario)(registroDispatch);
      }
    }
  };

  const isEmptyError = (empty, minLength = 0) => {
    if (empty === "") {
      return true;
    }
    // Verificar que no sea solo espacios
    if (empty.trim() === "") {
      return true;
    }
    // Verificar longitud del valor sin espacios al inicio/fin
    if (minLength > 0 && empty.trim().length < minLength) {
      return true;
    }
    return false;
  };
  const onDomicilioChange = (e) => {
    const valorNuevo = e.target.value;
    const valorActual = registroState.registro.usuario.domicilio;

    // Permitir campo vacío
    if (valorNuevo === "") {
      let errx = { ...registroState.registro.listError };
      errx.domicilio = true;
      setListError(errx)(registroDispatch);

      let usuario = { ...registroState.registro.usuario };
      usuario.domicilio = "";
      setUsuario(usuario)(registroDispatch);
      return;
    }

    // No permitir que el campo empiece con espacio
    if (valorActual === "" && valorNuevo.startsWith(" ")) {
      e.target.value = valorActual;
      showToaster(
        {
          texto: "El domicilio no puede empezar con espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);
      return;
    }

    // Filtro genérico por regex
    const { esValido, valorSanitizado } = filtrarPorRegex(
      valorNuevo,
      regexDomicilio
    );

    if (!esValido) {
      // Revertimos visualmente al último valor válido
      e.target.value = valorActual;

      // Siempre muestro toaster cuando intenta ingresar algo inválido
      showToaster(
        {
          texto: "Caracteres no permitidos en el domicilio",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);

      // Solo marco error si el campo está vacío o incompleto
      if (!valorActual || valorActual.length < 4) {
        let errx = { ...registroState.registro.listError };
        errx.domicilio = true;
        setListError(errx)(registroDispatch);
      }
      return;
    }

    // Verificar si solo son espacios
    if (valorSanitizado.trim() === "") {
      showToaster(
        {
          texto: "El domicilio no puede contener solo espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);

      let errx = { ...registroState.registro.listError };
      errx.domicilio = true;
      setListError(errx)(registroDispatch);

      e.target.value = valorActual;
      return;
    }

    let errx = { ...registroState.registro.listError };
    errx.domicilio = isEmptyError(valorSanitizado, 4);
    setListError(errx)(registroDispatch);

    let usuario = { ...registroState.registro.usuario };
    usuario.domicilio = valorSanitizado;
    setUsuario(usuario)(registroDispatch);
  };

  const onTelFijoChange = (e) => {
    const valorNuevo = e.target.value;
    const valorActual = registroState.registro.usuario.telefono;

    // Permitir campo vacío (no es requerido)
    if (valorNuevo === "") {
      let usuario = { ...registroState.registro.usuario };
      usuario.telefono = "";
      setUsuario(usuario)(registroDispatch);
      return;
    }

    // No permitir que el campo empiece con espacio
    if (valorActual === "" && valorNuevo.startsWith(" ")) {
      e.target.value = valorActual;
      showToaster(
        {
          texto: "El teléfono no puede empezar con espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);
      return;
    }

    // Filtro genérico por regex (permite números y espacios)
    const { esValido, valorSanitizado } = filtrarPorRegex(
      valorNuevo,
      regexTelefono
    );

    if (!esValido) {
      // Revertimos visualmente al último valor válido
      e.target.value = valorActual;

      // Siempre muestro toaster cuando intenta ingresar algo inválido
      showToaster(
        {
          texto: "Solo se permiten números y espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);
      return;
    }

    let usuario = { ...registroState.registro.usuario };
    usuario.telefono = valorSanitizado;
    setUsuario(usuario)(registroDispatch);
  };

  useEffect(() => {
    if (
      validaMobileState.validaMobile.data !== null &&
      validaMobileState.validaMobile.data !== undefined
    ) {
      let errx = Object.assign({}, registroState.registro.listError);
      errx.telefono_movil = !validaMobileState.validaMobile.data;
      if (!validaMobileState.validaMobile.data) {
        errx.telefono_movil = true;
        setListError(errx)(registroDispatch);
      } else {
        errx.telefono_movil = false;
        setListError(errx)(registroDispatch);
      }
    }
  }, [validaMobileState.validaMobile]);

  const onTelMobileChange = (e) => {
    const valorNuevo = e.target.value;
    const valorActual = registroState.registro.usuario.telefono_movil;

    // Permitir campo vacío
    if (valorNuevo === "") {
      let errx = { ...registroState.registro.listError };
      errx.telefono_movil = true;
      setListError(errx)(registroDispatch);

      let usuario = { ...registroState.registro.usuario };
      usuario.telefono_movil = "";
      setUsuario(usuario)(registroDispatch);
      return;
    }

    // No permitir que el campo empiece con espacio
    if (valorActual === "" && valorNuevo.startsWith(" ")) {
      e.target.value = valorActual;
      showToaster(
        {
          texto: "El teléfono no puede empezar con espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);
      return;
    }

    // Filtro genérico por regex (permite números y espacios)
    const { esValido, valorSanitizado } = filtrarPorRegex(
      valorNuevo,
      regexTelefono
    );

    if (!esValido) {
      // Revertimos visualmente al último valor válido
      e.target.value = valorActual;

      // Siempre muestro toaster cuando intenta ingresar algo inválido
      showToaster(
        {
          texto: "Solo se permiten números y espacios",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);

      // Solo marco error si el campo está vacío o incompleto
      if (
        !valorActual ||
        valorActual.length === 0 ||
        registroState.registro.listError.telefono_movil
      ) {
        let errx = { ...registroState.registro.listError };
        errx.telefono_movil = true;
        setListError(errx)(registroDispatch);
      }
      return;
    }

    validaMobile(valorSanitizado)(validaMobileDispatch);
    let errx = { ...registroState.registro.listError };
    errx.telefono_movil = isEmptyError(valorSanitizado);
    setListError(errx)(registroDispatch);

    let usuario = { ...registroState.registro.usuario };
    usuario.telefono_movil = valorSanitizado;
    setUsuario(usuario)(registroDispatch);
  };

  useEffect(() => {
    setTimeout(() => {
      if (document.getElementsByName("txtNombre")[0] !== undefined) {
        document.getElementsByName("txtNombre")[0].focus();
        document.getElementsByName("txtNombre")[0].focus();
      }
    }, 250);
  }, []);

  const setMultitab = (paso) => {
    // Primero aplicamos trim a los campos antes de validar
    let usuario = { ...registroState.registro.usuario };
    usuario.nombre = usuario.nombre?.trim() || "";
    usuario.apellido = usuario.apellido?.trim() || "";
    usuario.email = usuario.email?.trim() || "";
    usuario.domicilio = usuario.domicilio?.trim() || "";
    setUsuario(usuario)(registroDispatch);

    // Ahora validamos con los valores ya trimmed
    let errx = Object.assign({}, registroState.registro.listError);
    errx.nombre = isNombreApellidoError(usuario.nombre, 3, true);
    errx.apellido = isNombreApellidoError(usuario.apellido, 3, true);
    errx.email = isErrorEmail(usuario.email);
    errx.fecha_nacimiento = isEmptyError(usuario.fecha_nacimiento);
    errx.idlocalidad = isLocalidadError(usuario.idlocalidad);
    errx.domicilio = isEmptyError(usuario.domicilio, 4);
    //consulto nuevamente si ya tenia el error, ya que estoy validando contra el ws.
    if (!registroState.registro.listError.telefono_movil) {
      errx.telefono_movil = isEmptyError(usuario.telefono_movil);
    }
    setListError(errx)(registroDispatch);
    let flgError = false;
    campos.forEach((item) => {
      if (errx[item]) flgError = true;
    });
    if (flgError) {
      showToaster(
        {
          texto:
            "Por favor, ingresá todos los campos requeridos en el formulario.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      setPasoMultiTab(paso)(multiTabDispatch);
    }
  };

  function fechaMenos119Anios() {
    const hoy = new Date();
    const fechaResultante = new Date(
      hoy.getFullYear() - 119,
      hoy.getMonth(),
      hoy.getDate()
    );
    const anio = fechaResultante.getFullYear();
    const mes = String(fechaResultante.getMonth() + 1).padStart(2, "0"); // Meses en JavaScript son 0-11
    const dia = String(fechaResultante.getDate()).padStart(2, "0");
    return `${anio} ${mes} ${dia}`;
  }

  return (
    <IonGrid className="ptur-registro-scroll">
      <IonRow>
        <IonCol className="ptur-ion-col" size="12" sizeMd="6">
          <InputV1
            inputType="text"
            name="txtNombre"
            headerStr="Nombre"
            placeholderText="Juan Carlos"
            errorStr="Ingresá tu nombre"
            onChange={onNombreChange}
            maxLength="20"
            value={registroState.registro.usuario.nombre}
            className="rb16m"
            checkError={registroState.registro.listError.nombre}
            isRequired={true}
            tabIndex="1"
            autoComplete="nope"
          />
        </IonCol>
        <IonCol className="ptur-ion-col" size="12" sizeMd="6">
          <InputV1
            inputType="text"
            name="txtApellido"
            headerStr="Apellido"
            placeholderText="Dominguez"
            errorStr="Ingresá tu apellido"
            onChange={onApellidoChange}
            maxLength="20"
            value={registroState.registro.usuario.apellido}
            className="rb16m"
            checkError={registroState.registro.listError.apellido}
            isRequired={true}
            tabIndex="2"
            autoComplete="nope"
          />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className="ptur-ion-col" size="12" sizeMd="6">
          <div style={{ marginTop: "14px" }}>
            <DatePicker
              headerStr="Fecha de nacimiento"
              fechaInicial={fechaMenos119Anios()}
              fechaFinal={`${hoy.getFullYear()} ${
                hoy.getMonth() + 1
              } ${hoy.getDate()}`}
              onChange={onFechaNacChange}
              selectedFecha={
                registroState.registro.usuario.fecha_nacimiento !== ""
                  ? registroState.registro.usuario.fecha_nacimiento +
                    "T00:00:00"
                  : false
              }
              customCss={"cursor:pointer rb16m"}
              checkError={registroState.registro.listError.fecha_nacimiento}
              errorStr="Seleccioná tu fecha de nacimiento"
              isRequired={true}
            />
          </div>
        </IonCol>
        <IonCol className="ptur-ion-col" size="12" sizeMd="6">
          <InputV1
            inputType="email"
            name="txtEmail"
            headerStr="Email"
            placeholderText="juan@gmail.com"
            errorStr={
              registroState.registro.usuario.email === ""
                ? "Ingresá tu email"
                : "Ingresá un email válido"
            }
            onChange={onEmailChange}
            maxLength="200"
            value={registroState.registro.usuario.email}
            className="rb16m"
            checkError={registroState.registro.listError.email}
            isRequired={true}
            autoComplete="nope"
          />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className="ptur-ion-col" size="12" sizeMd="6">
          <Dropdown
            headerStr="Localidad"
            datos={localidadState.localidad.data}
            onChange={onLocalidadChange}
            campoCodigo="id"
            descripcion="descripcion"
            placeholder="Busca tu localidad"
            name="txtLocalidad"
            errorStr="Seleccioná tu localidad"
            checkError={registroState.registro.listError.idlocalidad}
            valor={valueLocalidad}
            mobileWidth={true}
            isRequired={true}
            autoComplete="off"
          />
        </IonCol>
        <IonCol className="ptur-ion-col" size="12" sizeMd="6">
          <InputV1
            inputType="text"
            headerStr="Domicilio"
            name="txtDomicilio"
            placeholderText="Av. Rivadavia 14252"
            errorStr="Ingresá tu domicilio"
            onChange={onDomicilioChange}
            maxLength="30"
            value={registroState.registro.usuario.domicilio}
            className="rb16m"
            checkError={registroState.registro.listError.domicilio}
            isRequired={true}
            autoComplete="nope"
          />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className="ptur-ion-col" size="12" sizeMd="6">
          <InputV1
            inputType="text"
            name="txtTelefono"
            headerStr="Teléfono fijo"
            placeholderText="011 1234 5678"
            // errorStr="El teléfono fijo es requerido"
            onChange={onTelFijoChange}
            maxLength="14"
            value={registroState.registro.usuario.telefono}
            className="rb16m"
            isRequired={false}
            autoComplete="nope"
          />
        </IonCol>
        <IonCol className="ptur-ion-col" size="12" sizeMd="6">
          <InputV1
            inputType="text"
            name="txtTelefonoMovil"
            headerStr="Teléfono móvil"
            placeholderText="011 1234 5678"
            errorStr={
              registroState.registro.usuario.telefono_movil === ""
                ? "Ingresá tu teléfono móvil"
                : "Ingresá un teléfono válido"
            }
            onChange={onTelMobileChange}
            maxLength="14"
            value={registroState.registro.usuario.telefono_movil}
            className="rb16m"
            checkError={registroState.registro.listError.telefono_movil}
            isRequired={true}
            autoComplete="nope"
          />
        </IonCol>
      </IonRow>
      <div className="ptur-footer-registros">
        <div className="ptur-footer-alignSiguientePaso">
          <button
            onClick={() => setMultitab(1)}
            className="btn ptur-btn-siguiente bgc-primary c-white rb16m"
          >
            Siguiente paso
          </button>
        </div>
      </div>
    </IonGrid>
  );
};
export default Paso1;
